module.exports = __webpack_public_path__ + "static/media/AA.7c1c5eb5.png";